import { useMutation } from '@tanstack/react-query';
import { api } from 'api';

export const useReferralLinkRequest = () => {
  const { mutateAsync: getRefLink, isLoading } = useMutation({
    mutationFn: async (userId) => {
      const { data } = await api.getReferralLink(userId);

      return data;
    },
    enabled: false,
  });

  return {
    getRefLink,
    isLoading,
  };
};
